import React, {useRef} from 'react'

interface IProps {
    id: string
    className?: string
    label?: string
    disabled?: boolean
    value?: boolean
    onChanged?: (isChecked: boolean) => void
}

const CheckBox: React.FC<IProps> = ({id, className, label, value, disabled = false, onChanged}) => {
    const inputRef = useRef(null)

    return (
        <div className={`flex items-center gap-x-2 ${className} transition-all duration-300 hover:scale-105`}>
            <input
                id={id}
                type="checkbox"
                ref={inputRef}
                checked={value}
                className={'w-5 h-5 peer accent-primary rounded-sm cursor-pointer border-2 transition-all duration-300 focus:ring-2 focus:ring-primary/30 checked:border-primary'}
                disabled={disabled}
                onChange={event => {
                    onChanged && onChanged(event.target.checked)
                }}
            />
            <label htmlFor={id} className={'text-gray-700 font-medium cursor-pointer select-none peer-disabled:text-gray3 transition-colors duration-300 hover:text-primary'}>
                {label}
            </label>
        </div>
    )
}

export default CheckBox
